import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Plus, Download, BarChart3, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { t, getLang } from "@/i18n";
import { ease } from "./motion";

const greeting = () => { const h = new Date().getHours(); return h < 12 ? "Buenos días" : h < 19 ? "Buenas tardes" : "Buenas noches"; };

export const Hero = ({ user, staff, stats }) => {
  const navigate = useNavigate();
  const [now, setNow] = useState(new Date());
  useEffect(() => { const id = setInterval(() => setNow(new Date()), 30000); return () => clearInterval(id); }, []);
  const date = now.toLocaleDateString(getLang() === "es" ? "es-MX" : "en-US", { weekday: "long", day: "numeric", month: "long" });
  const live = stats?.by_status?.approved || 0;
  return (
    <motion.section initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, ease }}
      className="hero relative overflow-hidden rounded-2xl border border-border p-6 sm:p-8" data-testid="dashboard-hero">
      <div className="hero-orb hero-orb-a" /><div className="hero-orb hero-orb-b" /><div className="hero-grid" />
      <div className="relative flex flex-wrap items-end justify-between gap-6">
        <div className="min-w-0">
          <motion.p initial={{ opacity: 0, x: -10 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.15, duration: 0.5 }} className="eyebrow flex items-center gap-2">
            <span className="h-1.5 w-1.5 rounded-full bg-primary pulse-dot" /> {t("Panel de control")} · <span className="capitalize">{date}</span>
          </motion.p>
          <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight mt-2 leading-[1.05]">
            {t(greeting())}, <span className="text-shine">{user.name.split(" ")[0]}</span>
          </h1>
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.35, duration: 0.6 }} className="text-sm text-muted-foreground mt-3 max-w-xl flex items-center gap-2" data-testid="hero-subtitle">
            <Sparkles className="h-3.5 w-3.5 text-primary" />
            {live > 0 ? t("Tienes {n} lanzamientos aprobados y sonando en las plataformas.", { n: live }) : t("Tu catálogo, distribución y pagos en un solo lugar.")}
          </motion.p>
        </div>
        <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3, duration: 0.5 }} className="flex flex-wrap items-center gap-2">
          <Button variant="outline" onClick={() => navigate("/analiticas")} data-testid="hero-btn-analytics" className="gap-2 bg-background/60 backdrop-blur"><BarChart3 className="h-4 w-4" /> {t("Analíticas")}</Button>
          {staff && <Button variant="outline" onClick={() => navigate("/importar")} data-testid="hero-btn-import" className="gap-2 bg-background/60 backdrop-blur"><Download className="h-4 w-4" /> {t("Importar")}</Button>}
          <Button onClick={() => navigate("/lanzamientos/nuevo")} data-testid="btn-create-release" className="gap-2 btn-glow"><Plus className="h-4 w-4" /> {t("Nuevo lanzamiento")}</Button>
        </motion.div>
      </div>
    </motion.section>
  );
};
